import React from "react";
import useGlobalModel from "@/model/globalModel";
import { useAcctUnitModel } from "../acctUnitModel";
import { YhPageHeader } from "@/components2/YhPageHeader";
import { SearchTypeEnum, ISearchValue } from "@/components2/YhPageHeader/Types";
import { useMdmModel } from "@/model/mdmModel";


export function PageHeader() {
    const { entity, shop } = useMdmModel();
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useAcctUnitModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "内部核算单位",
            fieldName: "name",
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "关联门店",
            fieldName: "shop",
            options: shop
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "关联实体",
            fieldName: "bentity",
            options: entity
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "状态",
            fieldName: "status",
            options: [{ label: "启用", value: "1" }, { label: "禁用", value: "0" }]
        }
    ]


    return (
        <YhPageHeader
            title="内部核算单位"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}